module.exports = __webpack_public_path__ + "static/blog22-f329df0dd1143dafb97a2388e3e539af.png";